import './lib/bugsnag' // eslint-disable-line import/order
import '../css/success.scss'

import {
  accessToken as previousAccessToken,
  storeCredentials,
} from './lib/authentication'
import { BroadcastMessageType, broadcastMessage } from './lib/broadcastMessage'
import { postCredentialsToChromeExtension } from './lib/util'

const queryParams = new URLSearchParams(window.location.search)

const accessToken = queryParams.get('token') || previousAccessToken
const accountId = queryParams.get('identity_account_id')
const viaSaml = queryParams.get('via_saml')

function sendCredentialsToOpener() {
  if (!window.opener) return false

  broadcastMessage({
    type: BroadcastMessageType.AuthSuccess,
    value: { accessToken, accountId, viaSaml },
    source: window.opener,
  })

  // Ensure broadcasted messages are processed in contexts where closing the
  // popup also closes the opener, i.e. the Chrome extension popup
  setTimeout(window.close, 100)

  return true
}

if (accessToken && accountId) {
  try {
    // Removes access token and account id from success URL
    // It also removes it from the browser history in Chrome and Edge
    history.replaceState({}, '', window.location.href.split('?')[0])
  } catch {} // eslint-disable-line no-empty

  postCredentialsToChromeExtension(accountId, accessToken, viaSaml)

  if (!sendCredentialsToOpener()) {
    storeCredentials(accessToken, accountId, viaSaml)
  }
} else {
  window.close()
}
